import React, { useEffect } from "react";
import Card from "components/card";
import FormItem from "components/fields/FormItem";
import { useDispatch, useSelector } from "react-redux";
import { getTimeCardDetails } from "../../../../redux/timecard/timeCardState";
import dayjs from "dayjs";
import {
  DATE_FORMAT_MDY,
  TIME_FORMAT_12HM,
} from "variables/constants";
import { NumberFormatter } from "utils";
import TimecardUpdateRequestTable from "../timecard-update-requests/components/TimecardUpdateRequestTable";
import SectionHeader from "components/section/SectionHeader";

const TimeCardDetails = ({ ...props }) => {
  	const dispatch = useDispatch();
	const { recordId } = props;

  	const recordData = useSelector((state) => state.timeCard.timeCardDetails?.data);
	const authUser = useSelector((state) => state.auth.user);
	
	useEffect(() => {
		if (recordId) {
		dispatch(getTimeCardDetails(recordId));
		}
	}, [dispatch, recordId]);
  
	return (
		<>
			<Card className="dark-mode-card rounded-xl border-2 p-4">
				<SectionHeader title="Timecard Details"/>
				<div className="px-3">
					{recordData?.tmc_user_id !== authUser?.id &&
						<FormItem
							label="Employee Name"
							value={recordData?.tmc_employee_name || "-"}
							extra="col-span-2"
						/>
					}
					<div className="grid grid-cols-3">
						<FormItem
							label="Day"
							value={
							recordData?.tmc_date
								? dayjs(recordData.tmc_date).format("dddd")
								: "-"
							}
						/>

						<FormItem
							label="Date"
							value={
							recordData?.tmc_date
								? dayjs(recordData.tmc_date).format(DATE_FORMAT_MDY)
								: "-"
							}
							extra="col-span-2"
						/>
					</div>

					<div className="grid grid-cols-3">
						<FormItem
							label="Shift Schedule"
							value={recordData?.shift_string || "Rest Day"}
						/>

						<FormItem
							label="Time In / Time Out"
							value={
							<span>
								{recordData?.tmc_punch_in
								? dayjs(recordData.tmc_punch_in).format(TIME_FORMAT_12HM)
								: "-"}
								{" - "}
								{recordData?.tmc_punch_out
								? dayjs(recordData.tmc_punch_out).format(TIME_FORMAT_12HM)
								: "-"}
							</span>
							}
						/>
						<FormItem
							label="Worked Hours"
							value={
							recordData?.tmc_worked_hours > 0
								? NumberFormatter(recordData.tmc_worked_hours, 2)
								: "-"
							}
						/>
					</div>
				</div>
			</Card>
			{recordData?.timecard_update_requests?.length > 0 && (
				<TimecardUpdateRequestTable
					timecardId={recordData?.tmc_id}
					mode="view"
				/>
			)}
		</>
	);
};

export default TimeCardDetails;
